import { SendUploadCaptionControl } from '../components/SendUploadCaptionControl';
import React from 'react';
import styled from 'styled-components';
import { DialogFullScreen } from '@spotify-internal/encore-web';
import { useTranslation } from 'react-i18next';
const UploadImageDialog = styled(DialogFullScreen) `
  position: absolute;
  inset: 0;

  img {
    width: 96%;
    object-fit: cover;
  }

  footer {
    padding: 0;
  }
`;
export const UploadImageDialogWithCaption = ({ image, onClose, onSubmit, }) => {
    const { t, i18n } = useTranslation();
    return (React.createElement(UploadImageDialog, { bodyStyle: {}, onClose: onClose, dialogTitle: t('UPLOAD_IMAGE_TEXT'), body: React.createElement(React.Fragment, null, image !== '' && (React.createElement("img", { "aria-label": "preview", alt: "preview", src: image }))), footer: React.createElement(SendUploadCaptionControl, { onSubmit: onSubmit }), dir: i18n.dir() }));
};
//# sourceMappingURL=UploadImageDialogWithCaption.js.map